export const SUPPORT_EMAIL = 'help@thelocals.ru';
export const SUPPORT_PHONE = '8 (800) 333-13-68';